<ngx-skeleton-loader [theme]="{height: '14px', width:'20%', margin: '10px 80% 10px 0' }" appearance="line"></ngx-skeleton-loader>
<ngx-skeleton-loader [theme]="{height: '14px', width:'20%', 'margin-bottom': '8px' }" appearance="line"></ngx-skeleton-loader>
@for (item of [1, 2, 3]; track item) {
  <div>
    <ngx-skeleton-loader [theme]="{height: '40px', width:'47.5%', 'margin-right': '5%', 'margin-bottom': '10px' }" appearance="line"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="{height: '40px', width:'47.5%', 'margin-bottom': '10px' }" appearance="line"></ngx-skeleton-loader>
  </div>
}
<div>
  <ngx-skeleton-loader [theme]="{height: '30px', width:'100%', 'margin-right': '5%', 'margin-bottom': '10px' }" appearance="line"></ngx-skeleton-loader>
</div>
<div class="item-separator"></div>

<div class="toolbar">
  <ngx-skeleton-loader [theme]="{height: '40px', width:'100%', 'margin-bottom': '0px' }" appearance="line"></ngx-skeleton-loader>

  <div class="toolbar-chips">
    @for (chip of [1, 2, 3, 4, 5]; track chip) {
      <ngx-skeleton-loader [theme]="{height: '32px', width:'120px', 'margin-bottom': '0px' }" appearance="line"></ngx-skeleton-loader>
    }
  </div>
</div>

@for (item of [1, 2, 3]; track item) {
  <div class="product">
    <div class="product-core">
      <ngx-skeleton-loader
        class="product-image"
        [theme]="{height: '85px', width:'85px', 'margin-bottom': '0px' }"
        appearance="line"
      ></ngx-skeleton-loader>

      <div class="product-info">
        <ngx-skeleton-loader [theme]="{height: '18px', width:'80%', 'margin-bottom': '4px' }" appearance="line"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{height: '12px', width:'50%', 'margin-bottom': '0px' }" appearance="line"></ngx-skeleton-loader>
      </div>

      <div class="product-attributes">
        @for (attribute of [1, 2, 3, 4]; track attribute) {
          <ngx-skeleton-loader [theme]="{height: '48px', width:'100%', 'margin-bottom': '0px' }" appearance="line"></ngx-skeleton-loader>
        }
      </div>
    </div>

    <div class="product-prices">
      @for (price of [1, 2, 3, 4]; track price) {
        <ngx-skeleton-loader [theme]="{height: '16px', width:'100%', 'margin-bottom': '0px' }" appearance="line"></ngx-skeleton-loader>
      }
    </div>
  </div>
}
